/* eslint-disable no-unused-vars */
import DirectorService from "@/services/director";

import {  } from "./types";

export async function startJob({commit}, jobId) {
  const {data} = await DirectorService.startJob(jobId);
  return data;
}

export async function stopJob({commit}, jobId) {
  const {data} = await DirectorService.stopJob(jobId);
  return data;
}

export async function stopTask({commit}, params) {
  const {data} = await DirectorService.stopTask(params);
  return data;
}

export async function startBackgroundJob({commit}, jobId) {
  const {data} = await DirectorService.startBackgroundJob(jobId);
  return data;
}